<template>
    <div>
        <loader :show="enviando"/>
        <v-container grid-list-md>
            <v-layout row wrap>
                <!-- <v-flex xs12 md12> -->
                    <v-card class="elevation-10 mx-auto" width="100%">
                        <v-toolbar >
                            <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
                            <v-card-title><h3>Asistencia institucional</h3></v-card-title>
                        </v-toolbar>

                        <v-tabs
                            v-model="tab"
                            fixed-tabs
                            color="blue darken-3"
                            dark
                        >
                            <v-tabs-slider color="orange"></v-tabs-slider>
                            <v-tab href="#tab-1"> Asistencias </v-tab>
                            <v-tab href="#tab-2"> Cálculo de horario </v-tab>
                            <v-tab href="#tab-3"> Asignación de horario </v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="tab">
                            <v-tab-item value="tab-1" >
                                <asistencias 
                                    @enviandoStart="enviando=true"
                                    @enviandoStop="enviando=false"
                                />                                
                            </v-tab-item>
                            <v-tab-item value="tab-2" >
                                <calculo 
                                    @enviandoStart="enviando=true"
                                    @enviandoStop="enviando=false"
                                />
                            </v-tab-item>
                            <v-tab-item value="tab-3" >
                                <v-card flat>
                                    <v-card-text>
                                        <horarios />
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>

                        
                    </v-card>
                <!-- </v-flex> -->
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from '../../components/Loader'
import axios from 'axios'
import moment from 'moment'

import Asistencias from './empleados/index'
import Calculo from './calculo/index'
import Horarios from './horarios/index'

export default {
    name: 'AsisInstitucional',
	components: { Loader, Asistencias, Calculo, Horarios },
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId",
            "tableProps",
            "permisos",
            "role"
        ]),
        puedeAgregar(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 197) >= 0 ? true : false;
        },
    },
    data() {
        return {
            enviando:false,
            tab: null
        }
    },
    methods:{
    }
}
</script>